import { getLocale, middleware } from '@weapp/utils';
import React, {
  ComponentType, forwardRef, ForwardRefRenderFunction, Suspense,
} from 'react';
import { appName as _appName } from '../../constants';
import ebdcomsUtils from '../../utils/ebdcoms';

export type LoaderType = () => Promise<{
  default: React.ComponentType<any>;
}>;

let asyncLocale: any = null;

const getAsyncLocale = () => {
  if (!asyncLocale) {
    asyncLocale = getLocale('@weapp/ebdcoms');
  }
  return asyncLocale;
};

export interface LoadableComponentProps {
  appName?: string;
  name: string;
  loader: LoaderType;
  /** 是否依赖@weapp/ebdcoms */
  ebdcoms?: boolean;
  loading?: ComponentType<any>;
}

function Loadable(opts: LoadableComponentProps): ComponentType<any> {
  const {
    appName = _appName, name, loader, ebdcoms, loading = () => null,
  } = opts;

  const Com = React.lazy(() => {
    const promises = [getAsyncLocale()];

    if (ebdcoms) {
      promises.push(ebdcomsUtils.load());
    }

    return Promise.all(promises).then(loader);
  });

  const LoadableComponent: ForwardRefRenderFunction<unknown, any> = (props, ref) => (
    <Suspense weId={`${props.weId || ''}_ql6g4a`} fallback={loading}>
      <Com weId={`${props.weId || ''}_j2dytt`} {...props} ref={ref} />
    </Suspense>
  );

  LoadableComponent.displayName = 'LoadableComponent';

  return middleware(appName, name)(forwardRef(LoadableComponent));
}

export default Loadable;
